import { defineFormConfig } from "@src/components/business-form";
import type { ApiWsInplantContent } from "../../../../../../api/wsInplants";
import { BalanceDocType } from "@src/types/business/balanceDocType";

/** Значения формы элемента состава ВЗН УП. */
export interface WsInplantContentFormValues {
    leaveCardCode: number | null;
    leaveQty: number;
    arrivalQty: number;
    orderCode: number | null;
}

export interface WsInplantContentFormContext {
    docType: BalanceDocType;
    readonly: boolean;
    senderDivisionCode?: number;
}

export const wsInplantContentFormConfig = defineFormConfig<
    WsInplantContentFormValues,
    ApiWsInplantContent,
    WsInplantContentFormContext
>({
    fields: {
        leaveCardCode: {
            type: "number",
            nullable: true,
            label: "Карточка",
            validation: { required: true },
            map: "LeaveCardCode",
            disabled: (_values, ctx) => ctx.readonly || ctx.docType === BalanceDocType.Arrival,
        },
        leaveQty: {
            type: "number",
            label: "Выдано",
            validation: { required: true, min: 0 },
            map: "LeaveQty",
            disabled: (_values, ctx) => ctx.readonly || ctx.docType === BalanceDocType.Arrival,
        },
        arrivalQty: {
            type: "number",
            label: "Получено",
            validation: { required: true, min: 0 },
            map: "ArrivalQty",
            disabled: (_values, ctx) => ctx.readonly || ctx.docType === BalanceDocType.Leave,
        },
        orderCode: {
            type: "number",
            nullable: true,
            label: "Заказ",
            map: "OrderCode",
            disabled: (_values, ctx) => ctx.readonly,
        },
    },
    toDomainOverride: (_values, { auto }) => ({
        ...auto,
        LeaveCardCode: auto.LeaveCardCode ?? 0,
        OrderCode: auto.OrderCode ?? 0,
        ArrivalCardCode: auto.ArrivalCardCode ?? 0,
        ArrivalCardType: auto.ArrivalCardType ?? 0,
        LotCode: auto.LotCode ?? 0,
        ArticleOfExpense: auto.ArticleOfExpense ?? 0,
    }),
});
